import { useRef, useState, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Swal from "sweetalert2";

import Header from "../header";
import { Link } from "react-router-dom";
import styles from "../home/index.module.css";
import { logo, LogoImage } from "../imagepath";
import AuthServices from "../../services/AuthServices";
const faq = [
  {
    no: 1,
    question: "Who needs emergency preparedness training?",
    answer:
      "All schools, child care centers, and educational institutions need emergency preparedness training. In an emergency, your staff becomes the first responder. AngelWatch ensures your entire team knows exactly what to do — and helps you meet state licensing and audit requirements.",
  },
  {
    no: 2,
    question: "What does AngelWatch certification include?",
    answer:
      "AngelWatch Certification includes complete online training for active shooter response, lockdown drills, fire safety, medical emergencies, and natural disasters. Staff receive official certificates upon completion, and administrators gain access to a full compliance dashboard to track training and maintain licensing standards.",
  },
  {
    no: 3,
    question: "How long does training take?",
    answer:
      "Most staff members complete their initial training in just a few hours. Courses are designed for maximum flexibility — they can be paused and resumed anytime, ensuring minimal disruption to your school or daycare schedule.",
  },
  {
    no: 4,
    question: "Is AngelWatch training state-approved?",
    answer:
      "Yes. AngelWatch meets or exceeds most state licensing requirements for emergency preparedness training. Our system provides the documentation and certificates required for audits, inspections, and legal compliance.",
  },
  {
    no: 5,
    question: "What happens if my staff needs retraining?",
    answer:
      "AngelWatch provides automatic annual recertification reminders. Staff can easily retake updated courses as needed to ensure your school or center stays 100% compliant without extra administrative burden.",
  },
  {
    no: 6,
    question: "How does AngelWatch help with inspections and audits?",
    answer:
      "Our Emergency Management Dashboard tracks staff certifications and generates reports for licensing inspections. AngelWatch clients report faster, easier inspections — and greater confidence during regulatory reviews.",
  },
  {
    no: 7,
    question: "Is this training state approved?",
    answer:
      "Yes. Our Emergency Protocol Handbook and SOPs are written to meet or exceed state Division of Licensing standards nationwide.",
  },
  {
    no: 8,
    question: "Do I need to recertify?",
    answer:
      "Staff have unlimited access for 12 months. New hires can be trained anytime, and the system tracks when recertification is due.",
  },
  {
    no: 9,
    question: "What if we already have a plan?",
    answer:
      "No problem. Our materials plug right in. If your current plan is incomplete, we’ll rewrite it for free to make it compliant.",
  },
  {
    no: 10,
    question: "Do you offer support?",
    answer:
      "Yes. You can email or call us anytime with questions, onboarding help, or integration guidance.",
  },
  {
    no: 11,
    question: "Do you offer bulk pricing for districts or franchises?",
    answer: "Yes. Contact us directly for a quote.",
  },
  {
    no: 12,
    question: "Is there a maximum number of teachers who can watch it?",
    answer:
      "No. The Center Plan includes unlimited staff access for a full year—train as many staff members as you need.",
  },
  {
    no: 13,
    question: "Is there a maximum number of times it can be viewed?",
    answer:
      "No. The course can be watched and reviewed as many times as needed during the 12-month access period.",
  },
  {
    no: 14,
    question: "Can the same teacher watch it multiple times?",
    answer:
      "Yes. Staff can log in and review the course at any time throughout the year for refreshers or recertification.",
  },
  {
    no: 15,
    question: "Will this make me state compliant?",
    answer:
      "Yes. The training, SOPs, and protocol handbook were designed to align with state mandates and make you inspection-ready.",
  },
  {
    no: 16,
    question: "How long until I receive my certificate of completion?",
    answer:
      "Certificates are generated immediately upon successful completion of the interactive course and passing the test.",
  },
  {
    no: 17,
    question: "Where can I buy the products used in the videos?",
    answer:
      "Product links and recommendations will be provided after certification or can be accessed via our support team.",
  },
];

const Faq = () => {
  const [faqNo, setFaqNo] = useState(0);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

  const handleCaptchaChange = (value) => {
    if (value) {
      setIsCaptchaVerified(true);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();

    try {
      const response = await AuthServices.sendEmail(formData);
      console.log("response", response);
      Swal.fire({
        title: "Success!",
        text: "Sucessfully Sent!",
        icon: "success",
        confirmButtonText: "OK",
      });
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      Swal.fire({
        text: "Failed to Send!",
        icon: "info",
        confirmButtonText: "OK",
      });
    }
  };

  const handleFaqFunc = (no) => {
    setFaqNo(no);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header></Header>
      <section className="mb-5">
        <h1
          className="text-center p-5 m-auto"
          style={{ maxWidth: "1000px" }}
          title="School Safety Training"
        >
          Frequently Asked Questions About AngelWatch Certification and School
          Safety Training
        </h1>
        <p className="m-auto text-center pb-5" style={{ maxWidth: "1000px" }}>
          We know that choosing the right emergency training program for your
          school or daycare is an important decision. Below are answers to the
          most common questions about AngelWatch’s nationally recognized
          certification, emergency management system, and compliance solutions.
        </p>
        {faq.map((item) => {
          console.log("item", item);
          return (
            <div className={styles.faq__item} key={item.no}>
              <div className={styles.faq__content}>
                <h2 className={styles.faq__title}>{item.question}</h2>
                <h2
                  className={styles.faq__add}
                  onClick={() => handleFaqFunc(item.no)}
                >
                  {faqNo === item.no ? `-` : `+`}
                </h2>
              </div>
              <p
                className={`${styles.faq__answer} ${
                  faqNo === item.no ? styles["faq__answer--show"] : ""
                }`}
              >
                {item.answer}
              </p>
            </div>
          );
        })}
      </section>
      <div className={styles.cta}>
        <h1 className={`text-white ${styles.cta__title}`}>
          Protect your children. Protect your staff. Stay compliant.
        </h1>
        <Link to="/getCertified">
          <button className={styles.cta__button}>
            Protect Your School Now -&gt;
          </button>
        </Link>
      </div>
      <section className={styles.contact__section}>
        <h1 className={styles.contact__heading}>Contact Us</h1>
        <div className={styles.contact}>
          <div>
            <h2 className={styles.contact__title}>
              For more information contact us
            </h2>
            <div>
              <img src={LogoImage} className={styles.contact__logoImg}></img>
            </div>
            <div>
              <div className={styles.contact__list}>
                <img
                  src={require("../../assets/img/email.png")}
                  className={styles.contact__img}
                ></img>
                <p className={styles.contact__item}>Edu@AngelWatch.org</p>
              </div>
              <div className={styles.contact__list}>
                <img
                  src={require("../../assets/img/call.png")}
                  className={styles.contact__img}
                ></img>
                <p className={styles.contact__item}>+1 800-381-6794</p>
              </div>
            </div>
          </div>
          <div className={styles.contact__form}>
            <div>
              <p>Your name</p>
              <input
                type="text"
                className={styles.contact__input__info}
                placeholder="John Smith"
              ></input>
            </div>
            <div>
              <p>Your email</p>
              <input
                type="email"
                className={styles.contact__input__info}
                placeholder="abc@gmail.com"
              ></input>
            </div>
            <div className={styles.contact__message__form}>
              <p>Your message</p>
              <textarea
                type="text"
                className={styles.contact__message__input}
              ></textarea>
            </div>
            <button style={{ marginBottom: "20px" }}>Send Message</button>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_SITE_KEY}
              className={`${styles.captcha}`}
            />
          </div>
        </div>
      </section>

      {/* Master Skills */}
      {/* /Master Skills */}
      <section className={styles.contact__section}>
        <h1 className={styles.contact__heading}>Contact Us</h1>
        <div className={styles.contact}>
          <div>
            <h2 className={styles.contact__title}>
              For more information contact us
            </h2>
            <div>
              <img src={LogoImage} className={styles.contact__logoImg}></img>
            </div>
            <div>
              <div className={styles.contact__list}>
                <img
                  src={require("../../assets/img/email.png")}
                  className={styles.contact__img}
                ></img>
                <p className={styles.contact__item}>Edu@AngelWatch.org</p>
              </div>
              <div className={styles.contact__list}>
                <img
                  src={require("../../assets/img/call.png")}
                  className={styles.contact__img}
                ></img>
                <p className={styles.contact__item}>+1 800-381-6794</p>
              </div>
            </div>
          </div>
          <div className={styles.contact__form}>
            <div>
              <p>Your name</p>
              <input
                type="text"
                className={styles.contact__input__info}
                placeholder="John Smith"
                name="name"
                value={formData.name}
                onChange={handleChange}
              ></input>
            </div>
            <div>
              <p>Your email</p>
              <input
                type="email"
                name="email"
                className={styles.contact__input__info}
                placeholder="abc@gmail.com"
                value={formData.email}
                onChange={handleChange}
              ></input>
            </div>
            <div className={styles.contact__message__form}>
              <p>Your message</p>
              <textarea
                type="text"
                name="message"
                className={styles.contact__message__input}
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            <button
              style={{ marginBottom: "20px" }}
              onClick={handleSendMessage}
              disabled={!handleCaptchaChange}
            >
              Send Message
            </button>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_SITE_KEY}
              onChange={handleCaptchaChange}
              className={`${styles.captcha}`}
            />
          </div>
        </div>
      </section>

      {/* Master Skills */}
      {/* /Master Skills */}
      <section className="d-flex flex-column">
        <div className={styles.footerTop}>
          <div className={styles.footerSection}>
            <img className={styles.footerImage} src={logo} />
            <p className={styles.footerDes}>
              All of our techniques, trainings, equipment, software, hardware,
              and instructional materials are classified and proprietary to the
              AngelWatch Foundation. We do not publicly disclose our teaching
              methodologies. This confidentiality is essential to ensure the
              ongoing safety and security of our centers, staff, and the
              children entrusted to our care. By continuously improving,
              adapting, and evolving our systems, we remain one step
              ahead—proactively closing any potential gaps and ensuring every
              base is covered.
            </p>
          </div>

          <div className={styles.footerLoginSection}>
            <p className={styles.footerTitle}>School</p>
            <Link to="/login">
              <a className={styles.footerLink1}>Login</a>
            </Link>
            <Link to="/selectregister">
              <a className={styles.footerLink1}>Register</a>
            </Link>
          </div>

          <div className={styles.footerSection}>
            <p className={styles.footerTitle}>Newsletter</p>
            <input
              className={styles.newsLetter}
              placeholder="Enter your email address"
              type="text"
            />
            <p className={styles.footerLink1}>
              Hampton Reserve Drive, Brentwood tennessee, 37027
            </p>
            <p className={styles.footerLink1}>Edu@AngelWatch.org</p>
            <p className={styles.footerLink1}>+1 800-381-6794</p>
          </div>
        </div>
        <div className={styles.footerBottom}>
          <div className={styles.footerBottomLeft}>
            <p className={styles.footerLink}>Term</p>
            <p className={styles.footerLink}>|</p>
            <p className={styles.footerLink}>Privacy</p>
          </div>
          <div className={styles.footerBottomRight}>
            <p className={styles.footerLink}>
              © 2025 AngelWatch LMS. All rights reserved.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
